module.exports = __webpack_public_path__ + "static/media/white-start-search-modal.aa8f0a8b.svg";